<template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              MARINA MISMO V2.
            </h2>
            <p class="vmc-text-primary-2 letter-spacing-1 mb-0">
              By Veritas Admin — May 04, 2025
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center pt-4">
            <p class="my-3 text-left">
              The target date to launch the version 2 (V2) will be on 01 May 2025. In V2, all details will be viewed before submitting and users need to make sure that SIRB Stamp and Sea Service has same data.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarinaMismoV22025"
}
</script>

<style scoped>

</style>
